import { render, staticRenderFns } from "./InstagramCommentReplyAsPrivate.vue?vue&type=template&id=2f5b1dd4"
import script from "./InstagramCommentReplyAsPrivate.vue?vue&type=script&lang=js"
export * from "./InstagramCommentReplyAsPrivate.vue?vue&type=script&lang=js"
import style0 from "./InstagramCommentReplyAsPrivate.vue?vue&type=style&index=0&id=2f5b1dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports